import axios, { AxiosError, AxiosResponse } from 'axios';
import { getLogger } from '../diagnostics/logger';
import { getSimManagementErrorFromAxiosError } from '.';
import { CompanyStatus } from '../models/companyStatus';

import config from '../config';
const log = getLogger('simManagement.api.companyStatusApi');

export function getById(id: number): Promise<CompanyStatus> {
  const url = config.API_BASE_URL + `api/company/${id}/status`;
  return new Promise<CompanyStatus>((resolve, reject) => {
    axios
      .get(url)
      .then((response: any) => {
        const result = response.data as CompanyStatus;
        resolve(result);
      })
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error as AxiosError);
        log.error(`Failed to load company ${id} status.`, simManagementError);
        reject(simManagementError);
      });
  });
}
